import { MarketplaceProductTypeEnum } from '@ria-client/supergraph/marketplace/constants';

export const INVESTING_COPY =
  'The investing information provided on this page is for educational purposes only. NerdWallet, Inc. does not offer advisory or brokerage services, nor does it recommend or advise investors to buy or sell particular stocks, securities or other investments.';

export const ADDITIONAL_MESSAGES: Partial<Record<MarketplaceProductTypeEnum, string>> = {
  [MarketplaceProductTypeEnum.Investing]: INVESTING_COPY,
  [MarketplaceProductTypeEnum.Retirement]: INVESTING_COPY,
};
